import client from "../api-client";

const URL = "proxy_usage.php";

export const get = () => {
  return client(URL).then(async (response) => {
    return await response;
  });
};
